import Proxy from '../Proxy';

class ExpenseCategoriesProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('expenses_categories', parameters);
  }
}

export default ExpenseCategoriesProxy;
